import React from "react";
import {
  Alliance,
  Crime,
  GovernyInfo, ThiefActionType
} from "../../../../lib/types";
import OpponentCrimes from "./OpponentCrimes";

interface IProps {
  sender: number;
  gold: number;
  readyToThieves: boolean;
  crimeTypes: ThiefActionType[];
  limitingCrimes: number;
  crimesLimit: number;
  crimes: Crime[];
  opponent: Alliance;
}

const CrimesSection = ({
  sender,
  gold,
  readyToThieves,
  crimeTypes,
  limitingCrimes,
  crimesLimit,
  crimes,
  opponent
}: IProps) => (
  <div className="box" style={{ overflowX: "scroll" }}>
    <p className="text-info text-center">{limitingCrimes >= crimesLimit ? `Governorate has reached crimes limit` : ""}</p>
    <table className="table vertical-top">
      <thead>
      <tr>
        <th className="text-left">Governorate</th>
        <th className="text-center">Influence</th>
        <th className="text-center">Influence management</th>
        <th>Crime selection</th>
        <th>Sent crimes</th>
      </tr>
      </thead>
      <tbody>
      {
        opponent && opponent.members.map((target: GovernyInfo) => <OpponentCrimes
          sender={sender}
          gold={gold}
          readyToThieves={readyToThieves}
          crimeTypes={crimeTypes}
          target={target}
          opponentAlliance={opponent}
          targetCrimes={crimes.filter((crime: Crime) => crime.target.id === target.id)}
          limitReached={limitingCrimes >= crimesLimit}
        />)
      }
      </tbody>
    </table>
  </div>
)

export default CrimesSection;
